<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        errorCallback,
        variationId,
        featureIndex,
        performance,
        eventMergeId = null,
        cinemaInjectionContainerWidth = 1000,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/productline/variations/${variationId}`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_product_line_cinema_wrapper">
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaMeta={metaData}
            {performance}
            trackingEventMergeId={eventMergeId}
            loadedTrackingActionName="change"
            site="RecoDetailViewProductline"
            showTopInfo={true}
            personalisedUser={hasPersonalisedRecommendations}
        />
    </div>
{/if}

<style lang="scss">
    .reco_product_line_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
